module.exports = __webpack_public_path__ + "img/avatar-6.d8d6627e.png";